import { ArrayHelper } from "../../Helpers/ArrayHelper";
import { MathHelper } from "../../Helpers/MathHelper";
import { Property } from "../../RadObject";
import { CheckBoxList, CheckBoxListPropertyValues, ICheckBoxList } from "./CheckBoxList";

export type CheckBoxListFlagsPropertyValues =
    CheckBoxListPropertyValues
    & {
    };

export type CheckBoxListFlagsProperties = {
    [name in keyof CheckBoxListFlagsPropertyValues]: Property<CheckBoxListFlagsPropertyValues[name]>
};

export interface ICheckBoxListFlags extends ICheckBoxList, CheckBoxListFlagsProperties
{
}

export class CheckBoxListFlags extends CheckBoxList implements ICheckBoxListFlags
{
    protected override __initializeProperties(propertyValues: CheckBoxListFlagsPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.text.overrideGet(next =>
        {
            let
                value = next();

            if (!value)
                value = "None";

            return value;
        });
        this.value.overrideGet(next =>
        {
            let
                value = next(),
                arrayValue: number[];

            arrayValue = ArrayHelper.isArrayLike(value) ? value : [];

            return MathHelper.powersOfTwoFromArray(arrayValue);
        });
        this.value.overrideSet((value, next) =>
        {
            value =
                typeof value === "number"
                    ? MathHelper.powersOfTwoToArray(value)
                    : (Array.isArray(value) ? value : null);

            next(value);
        });
    }
}